import { CByteArray } from "./CByteArray";
import { CDefine, CEnumTypes, CMJHuType } from "./CEnumTypes";
import { CMJGame } from "./CMJGame";
import { CMJPlayer } from "./CMJPlayer";
import { CGame } from "./CGame";

export class CMJCore {
    protected m_MJ:CMJGame;
    protected m_Jiang:number;
    protected m_cntRes:number;
    protected m_typeRes:CByteArray;
	protected m_valRes:CByteArray;
    public m_cntHu:number;
    public m_cntHuDealer:number;
    public m_MJResult:CByteArray = new CByteArray(CMJHuType.MJHUO_MAXMATCH + 5);
    public m_MJConfig:CByteArray = new CByteArray(CMJHuType.MJHUO_MAXMATCH + 5);

    constructor(game:CMJGame) {
        var MJDefault = [ 1, 2, 0, 0, // 0, "莊家", "連莊", "", "台", 
					1, 1, 3, 1, 1, 1,       // 4, "門清", "自摸", "門清自摸", "槓上開花", "海底撈月", "搶槓", 
					2, 1, 1, 1, 1, 2, 8,    // 10, "全求", "獨聽", "門風", "圈風", "花牌", "花槓", "八仙過海", 
					2, 4, 2, 5, 8, 4,       // 17, "平胡","碰碰胡", "三暗刻", "四暗刻", "五暗刻", "混一色", 
					8, 4, 8, 8, 16, 8,      // 23, "清一色", "小三元", "大三元", "小四喜", "大四喜", "七搶一", 
					24, 16, 1, 1, 1, 1, 0,   // 29, "天胡", "地胡", "聽牌", "紅中", "青發", "白板", "屁胡", 
					8, 4,   				// 36, "天聽", "地聽", 
					1, 1, 1, 1, 1, 1, 2,	// 38, "東風", "南風", "西風", "北風", "無字無花", "槓牌", "暗槓", 
					0,						// 45, "河底撈魚"
					0, 0, 0, 0, 0, 0,       // 46, "字一色", "清老頭", "四槓", "斷么九", "雙龍抱", "三色同順", 
					0, 0, 0, 0 ];			// 52, "一條龍", "混全帶么", "純全帶么", "混老頭"
        for ( let i = 0; i < CMJHuType.MJHUO_MAXMATCH; i ++ ) {
            this.m_MJConfig[i] = MJDefault[i];
        }
        this.m_MJ = game;
        this.m_typeRes = new CByteArray(10);
	    this.m_valRes = new CByteArray(10);
        this.m_Jiang = 0;
        this.m_cntRes = 0;
    }

    public static GET_MJTYPE(v:number):number { 
        return ((v & 0x000000f0) >> 4);
    }
    public static GET_MJVALUE(v:number):number {
        return (v & 0x0000000f);
    }
}